import React from 'react';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import { Grid } from '@mui/material';

const ButtonCreateEditPaymentVoucher = ({
    check,
    isApprovedAcc,
    Save,
    DataRegUserAccess,
    isEdit,
    Print,
    AddNew,
    isUnapproved,
    Approve,
    UnApprove
}) => {

    const renderButtonByAccessCode = (accessCode) => {
        switch (accessCode) {
            case 'PRI':
                return isEdit && ButtonComponent.PrintButton(Print, '', true);
            case 'CRE':
                return isEdit && ButtonComponent.AddButton(AddNew, 'New', false, isUnapproved, true);
            case 'APP':
                return isEdit && !isApprovedAcc && ButtonComponent.ApproveButton(Approve, 'Approve', true);
            case 'UPP':
                return isEdit && isApprovedAcc ? ButtonComponent.UnApproveButton(UnApprove, 'Un Approve', true) : null;
            default:
                return null;
        }
    };

    return (
        <div className="row" style={{ marginTop: '16px' }}>
            <div className="col-12">
                <Grid
                    container
                    item
                    justifyContent="right"
                    direction="row"
                    style={{ maxWidth: "100vw", gap: "12px" }}
                >
                    {check !== 0 && !isApprovedAcc && ButtonComponent.SaveButton(() => Save(false), false, false, true)}

                    {DataRegUserAccess.map((data) => (
                        <React.Fragment key={data.accessId}>
                            {renderButtonByAccessCode(data.accessCode)}
                        </React.Fragment>
                    ))}
                </Grid>
            </div>
        </div>
    );
};

export default ButtonCreateEditPaymentVoucher;